import { Grid } from '@mui/material';
import { ReactNode } from 'react';

import { SettingsHeader } from '../../../components/SettingsHeader';
import SettingsIndex from '../../../components/SettingsIndex';
import { IBreadCrumbsList, WsBreadCrumbs } from '../../../components/WsBreadCrumbs';

type PropsType = {
  title: string;
  backUrl?: string;
  indexLabel: string;
  children: ReactNode;
  breadCrumbsList?: IBreadCrumbsList[];
};

const NotificationSettingsLayout = ({
  title,
  children,
  indexLabel,
  breadCrumbsList = [],
}: PropsType) => (
  <Grid container columnSpacing={3} rowSpacing={4}>
    <Grid item xs={12}>
      <WsBreadCrumbs breadCrumbsList={breadCrumbsList} />
      <SettingsHeader title={title} />
    </Grid>

    <Grid item xs={3}>
      <SettingsIndex index="" options={[{ label: indexLabel, url: '/notification-settings' }]} />
    </Grid>
    <Grid item xs={9}>
      {children}
    </Grid>
  </Grid>
);

export default NotificationSettingsLayout;
